<template>
  <div id="city-header">
    <v-row>
      <v-col class="cityName">
        <h2>{{ city }}</h2>

        <div v-if="isFullAdmin || user.grupo.nome == 'Operações'">
          <combobox-municipio
            @onChange="onChangeMunicipio"
          ></combobox-municipio>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!sumirHeader()">
      <v-col>
        <v-bottom-navigation
          :value="activeBtn"
          color="primary"
          class="navigationHeader"
        >
          <v-divider vertical></v-divider>

          <v-btn :to="'/cidade/' + cityId + '/geral'">
            <span>Geral</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              (config.acompanhamentos && groupsConfig.acompanhamentos)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/acompanhamento'"
            v-if="
              isFullAdmin ||
              ((isIndicadores || !isIndicadores) &&
                config.acompanhamentos &&
                groupsConfig.acompanhamentos)
            "
          >
            <span>Acompanhamentos</span>
          </v-btn>

          <v-divider
            v-if="isFullAdmin || (groupsConfig.evidencias && config.evidencias)"
            vertical
          ></v-divider>

          <v-btn
            :to="`${
              isSala
                ? '/cidade/' + cityId + '/evidencia/boasvindas'
                : '/cidade/' + cityId + '/evidencia/respondida'
            }`"
            v-if="isFullAdmin || (groupsConfig.evidencias && config.evidencias)"
          >
            <span>Evidências</span>
          </v-btn>

          <v-divider
            v-if="
              isFullAdmin ||
              (config.termoReferencia && groupsConfig.termoReferencia)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/termo-referencia/0'"
            v-if="
              isFullAdmin ||
              (config.termoReferencia && groupsConfig.termoReferencia)
            "
          >
            <span>{{
              isGov ? "Fases/Atividades" : "Termos de Referência"
            }}</span>
          </v-btn>

          <v-divider
            v-if="
              isFullAdmin ||
              ((!isNA || (config.grupos && groupsConfig.grupos)) &&
                !isIndicadores &&
                !isSala)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/grupo'"
            v-if="isFullAdmin || (config.grupos && groupsConfig.grupos)"
          >
            <span>{{
              $store.state.uf === "AL" || isAT
                ? "Grupos/Iniciativas"
                : isGov
                ? "Etapas/Grupos"
                : "Grupos"
            }}</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (config.calendario && groupsConfig.calendario)"
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/evento'"
            v-if="isFullAdmin || (config.calendario && groupsConfig.calendario)"
          >
            <span>{{ isGov ? "Agenda" : "Calendário" }}</span>
          </v-btn>
          <v-divider
            v-if="
              estado === 'SC1' && (isAdmin || isConsultorEspecialistaMunicipio)
            "
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/evento-em-lote'"
            v-if="
              estado === 'SC1' && (isAdmin || isConsultorEspecialistaMunicipio)
            "
          >
            <span>Calendário em Lote</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (config.relatorios && groupsConfig.relatorios)"
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/relatorio'"
            v-if="isFullAdmin || (config.relatorios && groupsConfig.relatorios)"
          >
            <span>Relatórios</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              (config.relatorioAdministrativo &&
                groupsConfig.relatorioAdministrativo)
            "
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/relatorio-administrativo'"
            v-if="
              isFullAdmin ||
              (config.relatorioAdministrativo &&
                groupsConfig.relatorioAdministrativo)
            "
          >
            <span>Relatório Administrativo</span>
          </v-btn>
          <v-divider
            v-if="
              isFullAdmin ||
              (config.verMenuProposta && groupsConfig.verMenuProposta)
            "
            vertical
          ></v-divider>
          <v-btn
            :to="'/cidade/' + cityId + '/proposta/proposta'"
            v-if="
              isFullAdmin ||
              (config.verMenuProposta && groupsConfig.verMenuProposta)
            "
          >
            <span>Proposta</span>
          </v-btn>
          <v-divider
            v-if="isFullAdmin || (config.andamento && groupsConfig.andamento)"
            vertical
          ></v-divider>

          <v-btn
            :to="'/cidade/' + cityId + '/andamento'"
            v-if="isFullAdmin || (config.andamento && groupsConfig.andamento)"
          >
            <span>Andamento</span>
          </v-btn>

          <v-divider
            v-if="isFullAdmin || (config.sala && groupsConfig.sala)"
            vertical
          ></v-divider>
          <v-btn
            v-if="isFullAdmin || (config.sala && groupsConfig.sala)"
            :to="'/sala-municipio-principal'"
          >
            <span>Sala</span>
          </v-btn>
          <v-divider vertical></v-divider>
          <template
            v-if="
              isFullAdmin ||
              (config.naoVerClienteOcultoOuro &&
                groupsConfig.naoVerClienteOcultoOuro &&
                payload &&
                payload.seloFinal &&
                payload.seloFinal.length > 0 &&
                payload.seloFinal[0].selo != 'Ouro') ||
              (!config.naoVerClienteOcultoOuro &&
                !groupsConfig.naoVerClienteOcultoOuro) ||
              (config.naoVerClienteOcultoOuro &&
                !groupsConfig.naoVerClienteOcultoOuro) ||
              (!config.naoVerClienteOcultoOuro &&
                groupsConfig.naoVerClienteOcultoOuro)
            "
          >
            <v-btn
              :to="`/cidade/${cityId}/cliente-oculto/info`"
              v-if="
                isFullAdmin ||
                (config.verClienteOculto && groupsConfig.verClienteOculto)
              "
            >
              <span>Cliente Oculto</span>
            </v-btn>
          </template>
        </v-bottom-navigation>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComboboxMunicipio from "./ComboboxMunicipio.vue";

export default {
  components: { ComboboxMunicipio },
  props: {
    payload: { type: Object },
  },
  data() {
    return {
      activeBtn: 0,
      estado: this.$store.state.uf,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  methods: {
    onChangeMunicipio(e) {
      this.$router.replace(`/cidade/${e}`);
      this.$emit("realod");
    },
    sumirHeader() {
      const acompanhamento =
        this.config.acompanhamentos && this.groupsConfig.acompanhamentos;
      const relatorios = this.config.relatorios && this.groupsConfig.relatorios;
      const calendario = this.config.calendario && this.groupsConfig.calendario;
      const evidencias = this.config.evidencias && this.groupsConfig.evidencias;
      const andamento = this.config.andamento && this.groupsConfig.andamento;
      const TR =
        this.config.termoReferencia && this.groupsConfig.termoReferencia;

      const relatorioAdmin =
        this.config.relatorioAdministrativo &&
        this.groupsConfig.relatorioAdministrativo;

      const sala = this.config.sala && this.groupsConfig.sala;
      const grupos = this.config.grupos && this.groupsConfig.grupos;
      const proposta =
        this.config.verMenuProposta && this.groupsConfig.verMenuProposta;
      const clienteOculto =
        this.config.verClienteOculto && this.groupsConfig.verClienteOculto;

      if (
        !this.isFullAdmin &&
        !acompanhamento &&
        !relatorios &&
        !calendario &&
        !evidencias &&
        !andamento &&
        !TR &&
        !relatorioAdmin &&
        !sala &&
        !grupos &&
        !proposta &&
        !clienteOculto
      ) {
        return true;
      }

      return false;
    },
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "city",
      "uf",
      "cityId",
      "urlTag",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin",
      "isNA",
      "isIndicadores",
      "isSala",
      "isAT",
      "isGov",
    ]),
  },
};
</script>

<style lang="scss">
.navigationHeader {
  .v-btn--active {
    background-color: var(--corPrimaria) !important;
    span {
      color: #fff;
    }
  }
}

.cityName {
  display: flex;
  align-items: center;
  column-gap: 2rem;
}
</style>
